export default "__VITE_ASSET__$iDCQK$b__"